import { Component, OnInit, ViewChild  } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import 'firebase/firestore';
import { Observable, from } from 'rxjs';
import { Youtubes } from 'src/app/model/youtubes'
import {
  SwiperConfigInterface,
  SwiperScrollbarInterface,
  SwiperPaginationInterface,
  SwiperDirective
} from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.css']
})
export class VideosComponent implements OnInit {
 
  youtubesCollection : AngularFirestoreCollection<Youtubes>;
  public youtube$: Observable<Youtubes[]>;
  youtubes : any;
  public show: boolean = true;

  public videosConfig: SwiperConfigInterface = {
    a11y: true,
    direction: 'horizontal',
    slidesPerView: 3,
    keyboard: true,
    mousewheel: true,
    scrollbar: false,
    navigation: false,
    pagination: false,
    spaceBetween: 0,
    autoplay: {
      delay: 4000,
      },
    loop: true, 
    
  };

  private scrollbar: SwiperScrollbarInterface = {
    el: '.videos-swiper-scrollbar',
    hide: false,
    draggable: true
  };

  private pagination: SwiperPaginationInterface = {
    el: '.videos-swiper-pagination',
    clickable: true,
    hideOnClick: false
  };

  @ViewChild(VideosComponent, { static: false }) componentRef?: VideosComponent;
  @ViewChild(SwiperDirective, { static: false }) directiveRef?: SwiperDirective;
  
  
  
  constructor(private afs:AngularFirestore) { 
    this.youtubesCollection = this.afs.collection<Youtubes>('youtubes');
    this.youtube$ = this.youtubesCollection.valueChanges();
  }
  
  ngOnInit(): void {
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    document.body.appendChild(tag);

    
  }

}
